import React from "react";
import { languageService } from "../../../../../Language/language.service";
import CommonModal from "components/Common/CommonModal";
import { ButtonStyle } from "../../../../../style/basic/commonControls";
import { themeService } from "../../../../../theme/service/activeTheme.service";
import DefectCodes from "components/IssuesReports/DefectCodes/DefectCodes";

export const DefectCodesModel = ({ methods, displayTitle, classToShow, maintenanceDefectCodesObj, assetTypes,showHideExpands }) => {
  return (
    <CommonModal
      headerText={languageService("Defect Codes")}
      setModalOpener={methods.setDefectCodeModel}
      footerCancelText={languageService("Close")}
    >
      <button className="setPasswordButton" onClick={methods.handleDefectCode} style={{ ...themeService(ButtonStyle.commonButton) }}>
        {displayTitle}
      </button>
      <DefectCodes showHideExpands={showHideExpands} classToShow={classToShow} selectedIssue={maintenanceDefectCodesObj} assetTypes={assetTypes} />
    </CommonModal>
  );
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/DetailViewModels/DefectCodesModel.jsx